import {TbMessage2Question} from "react-icons/tb";
import {GoInfo} from "react-icons/go";
import {Button} from "react-bootstrap";
import {useContext, useEffect} from "react";
import {useTranslation} from "react-i18next";
import AppContext from "../../AppContext";

export default function SingleMultiQuestion({ quiz, setQuiz, goNext }) {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if(quiz.question.correct.length <= 1 && quiz.answers.length > 0)
            submitAnswer()

    }, [quiz.answers])

    const noImage = quiz.question.image_uri === null || quiz.question.image_uri === ''

    const isSelected = (idx) => {
        return quiz.answers.indexOf(idx) !== -1
    }
    const isCorrect = () => {
        var correct = 0;
        quiz.answers.forEach((answer, idx) => {
            if(quiz.question.correct.indexOf(answer) !== -1)
                correct++;
        });

        return correct === quiz.question.correct.length
    }
    const selectAnswer = (idx) => {
        if(quiz.finished || quiz.lastResult !== -1)
            return

        let answers = [...quiz.answers]

        const ans = quiz.question.correct.length <= 1 ? [] : answers
        const index = ans.indexOf(idx)
        if(index === -1)
            ans.push(idx)
        else
            ans.splice(index, 1)

        setQuiz({...quiz, answers: ans })
    }

    const submitAnswer = () => {
        let q = {...quiz}
        const correct = isCorrect()
        if(correct)
            app.playSfxCorrect()
        else
            app.playSfxWrong()

        q.lastResult = correct ? 1 : 0
        q.results[quiz.questionIdx] = correct ? 1 : 0
        if(!correct) {
            q.perfect = false
            q.questions.push(q.questions[q.questionIdx])
        }
        setQuiz({...q})
    }

    return <div className={"quiz-question " + (noImage ? 'no-image' : '')}>
        <div className="q-image">
            {!noImage && <img src={quiz.question.image_uri} alt="" />}
            {noImage && <TbMessage2Question className="placeholder-image" />}
        </div>
        <div className="q-details">
            <ul className="q-answers">
                {quiz.question.answers.map((a, idx) => {
                    let c = ['btn-answer']
                    if(isSelected(idx))
                        c.push('selected')

                    if(process.env.REACT_APP_DEBUG_MODE === "true" && quiz.question.correct.indexOf(idx) !== -1)
                        c.push('correct')

                    if(quiz.lastResult !== -1) {
                        if(quiz.question.correct.indexOf(idx) !== -1)
                            c.push('correct')
                        else
                            c.push('wrong')
                    }
                    return <li key={idx}>
                        <button type="button" className={c.join(' ')} onClick={() => selectAnswer(idx)} dangerouslySetInnerHTML={{__html: a}} />
                    </li>
                })}
                {quiz.lastResult === -1 && quiz.question.correct.length > 1 &&
                    <li>
                        <p className="small text-muted"><GoInfo style={{fontSize: 16}} /> {t('quiz.multiNote')}</p>
                        <Button variant="primary" onClick={submitAnswer}>{t('button.submitAnswer')}</Button>
                    </li>}
                {quiz.lastResult === 1 &&
                    <li>
                        <h4 className="text-success fw-bold">{t('good')}</h4>
                        <p className="small text-muted" dangerouslySetInnerHTML={{__html: quiz.question.explanation}} />
                        <Button variant="primary" onClick={goNext}>{t('button.next')}</Button>
                    </li>}
                {quiz.lastResult === 0 &&
                    <li>
                        <h4 className="text-danger fw-bold">{t('wrong')}</h4>
                        <p className="small text-muted" dangerouslySetInnerHTML={{__html: quiz.question.explanation}} />
                        <Button variant="primary" onClick={goNext}>{t('button.next')}</Button>
                    </li>}
            </ul>
        </div>
    </div>
}